(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chapters-of-rehva"] && !Shopify.designMode) return;
  try {
    
  class ChaptersOfRehvaReveal extends HTMLElement {
    connectedCallback() {
      const targets = Array.from(
        this.querySelectorAll('.chapters-of-rehva__tile, .chapters-of-rehva__text, .chapters-of-rehva__headline')
      );
      const reducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));

      if (!targets.length || reducedMotion || !('IntersectionObserver' in window)) return;

      this.classList.add('chapters-of-rehva__reveal--ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = targets.indexOf(entry.target);
            entry.target.style.transitionDelay = `${Math.min(index, 8) * 60}ms`;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      targets.forEach((target) => observer.observe(target));
    }
  }

  if (!customElements.get('chapters-of-rehva-reveal')) {
    customElements.define('chapters-of-rehva-reveal', ChaptersOfRehvaReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-features"] && !Shopify.designMode) return;
  try {
    
  class RehvaFeaturesReveal extends HTMLElement {
    connectedCallback() {
      const items = Array.from(this.querySelectorAll('.rehva-features__item'));
      const reduceMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));

      if (!items.length || reduceMotion || !('IntersectionObserver' in window)) return;

      this.setAttribute('data-observed', '');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    }
  }

  if (!customElements.get('rehva-features-reveal')) {
    customElements.define('rehva-features-reveal', RehvaFeaturesReveal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-chapters-scroll"] && !Shopify.designMode) return;
  try {
    
  class RehvaChaptersScrollPin extends HTMLElement {
    connectedCallback() {
      this.sticky = this.querySelector('.chapters-scroll__sticky');
      this.cards = Array.from(this.querySelectorAll('.chapters-scroll__card'));
      this.progressCurrent = this.querySelector('.chapters-scroll__progress-current');
      this.progressFill = this.querySelector('.chapters-scroll__progress-fill');

      if (!this.sticky || this.cards.length < 2 || this.dataset.pin === 'false') {
        return;
      }

      // Horizon (base.css) makes html/body non-scrolling above 990px and
      // hands real scrolling to `.page-wrapper` instead — a plain
      // `window`'s `scroll` event never fires there, so we have to listen
      // on whichever element actually scrolls. `getBoundingClientRect()`
      // stays viewport-relative either way, so the progress math below
      // doesn't otherwise change.
      this.scroller = document.querySelector('.page-wrapper') || window;

      this.desktopQuery = window.matchMedia('(min-width: 1024px)');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = false;
      this.raf = null;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.evaluate = this.evaluate.bind(this);

      this.evaluate();

      window.addEventListener('resize', this.handleResize, { passive: true });
      if (this.desktopQuery.addEventListener) {
        this.desktopQuery.addEventListener('change', this.evaluate);
        this.motionQuery.addEventListener('change', this.evaluate);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.scroller.removeEventListener('scroll', this.handleScroll);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    getViewportHeight() {
      return this.scroller === window ? window.innerHeight : this.scroller.clientHeight;
    }

    evaluate() {
      const shouldPin = this.desktopQuery.matches && !this.motionQuery.matches && !document.documentElement.hasAttribute('data-rehva-motion-off');
      if (shouldPin === this.enabled) return;
      this.enabled = shouldPin;

      if (shouldPin) {
        this.classList.add('chapters-scroll__pin-wrap--active');
        this.updateHeight();
        this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
      } else {
        this.classList.remove('chapters-scroll__pin-wrap--active');
        this.style.height = '';
        this.cards.forEach((card) => {
          card.style.transform = '';
        });
        this.scroller.removeEventListener('scroll', this.handleScroll);
      }
    }

    updateHeight() {
      // One viewport-height of scroll per card: the first card gets its own
      // dwell, then each subsequent card gets a full vh of scroll to sweep
      // in and completely cover the one before it.
      this.style.height = `${this.getViewportHeight() * this.cards.length}px`;
    }

    handleResize() {
      this.evaluate();
      if (this.enabled) {
        this.updateHeight();
        this.handleScroll();
      }
    }

    handleScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        const rect = this.getBoundingClientRect();
        const viewportHeight = this.getViewportHeight();
        const total = rect.height - viewportHeight;
        const progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
        const scaled = progress * (this.cards.length - 1);

        this.cards.forEach((card, i) => {
          if (i === 0) {
            // The base card never moves — later cards sweep in on top of it.
            card.style.transform = 'translate3d(0, 0, 0)';
            return;
          }
          const local = Math.min(1, Math.max(0, scaled - (i - 1)));
          card.style.transform = `translate3d(${(1 - local) * 100}%, 0, 0)`;
        });

        if (this.progressFill) {
          this.progressFill.style.transform = `scaleX(${progress})`;
        }
        if (this.progressCurrent) {
          const index = Math.min(this.cards.length - 1, Math.round(scaled));
          this.progressCurrent.textContent = String(index + 1).padStart(2, '0');
        }
      });
    }
  }

  if (!customElements.get('rehva-chapters-scroll-pin')) {
    customElements.define('rehva-chapters-scroll-pin', RehvaChaptersScrollPin);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-current-drop"] && !Shopify.designMode) return;
  try {
    
  class RehvaDropCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.reduceMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));

      this.prevButton?.addEventListener('click', () => {
        this.goPrev();
        this.restart();
      });

      this.nextButton?.addEventListener('click', () => {
        this.goNext();
        this.restart();
      });

      this.track.addEventListener('scroll', () => this.updateNavState(), { passive: true });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.resizeObserver = new ResizeObserver(() => this.updateNavState());
      this.resizeObserver.observe(this.track);

      this.updateNavState();
      this.start();
    }

    getStep() {
      const firstCard = this.track.children[0];
      if (!firstCard) return this.track.clientWidth;
      const trackStyle = getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0');
      return firstCard.getBoundingClientRect().width + gap;
    }

    goNext() {
      const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
      if (atEnd) {
        this.track.scrollTo({ left: 0, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      } else {
        this.track.scrollBy({ left: this.getStep(), behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }
    }

    goPrev() {
      this.track.scrollBy({ left: -this.getStep(), behavior: this.reduceMotion ? 'auto' : 'smooth' });
    }

    updateNavState() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 4;
      this.classList.toggle('is-scrollable', scrollable);
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 4;
      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
      }
    }

    start() {
      if (this.reduceMotion || this.timer || this.dataset.autoplay !== 'true') return;
      this.timer = window.setInterval(() => this.goNext(), parseInt(this.dataset.autoplayMs, 10) || 4500);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.resizeObserver?.disconnect();
    }
  }

  if (!customElements.get('rehva-drop-carousel')) {
    customElements.define('rehva-drop-carousel', RehvaDropCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-header"]) return;
  try {
    
  class RehvaHeader extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-rehva-menu-toggle]');
      this.drawer = this.querySelector('[data-rehva-drawer]');
      this.closeButton = this.querySelector('[data-rehva-drawer-close]');
      this.overlay = this.querySelector('[data-rehva-drawer-overlay]');

      if (!this.toggle || !this.drawer) return;

      this.toggle.addEventListener('click', () => {
        if (this.hasAttribute('data-drawer-open')) {
          this.closeDrawer();
        } else {
          this.openDrawer();
        }
      });

      this.closeButton?.addEventListener('click', () => this.closeDrawer());
      this.overlay?.addEventListener('click', () => this.closeDrawer());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('data-drawer-open')) {
          this.closeDrawer();
        }
      });
    }

    openDrawer() {
      this.drawer.hidden = false;
      requestAnimationFrame(() => this.setAttribute('data-drawer-open', ''));
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const firstFocusable = this.drawer.querySelector('a, button');
      firstFocusable?.focus();
    }

    closeDrawer() {
      this.removeAttribute('data-drawer-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.toggle.focus();
      window.setTimeout(() => {
        if (!this.hasAttribute('data-drawer-open')) this.drawer.hidden = true;
      }, 300);
    }
  }

  if (!customElements.get('rehva-header')) {
    customElements.define('rehva-header', RehvaHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-hero"] && !Shopify.designMode) return;
  try {
    
  class RehvaHeroStage extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.playPauseButton = this.querySelector('[data-playpause]');
      this.total = this.slides.length;
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.dataset.state === 'active')
      );
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && this.total > 1;
      this.reducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));
      this.playing = this.autoplayEnabled && !this.reducedMotion;
      this.timer = null;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.index, 10));
          if (this.autoplayEnabled) {
            this.playing = true;
            this.updatePlayPauseUI();
            this.start();
          }
        });
      });

      this.playPauseButton?.addEventListener('click', () => {
        if (this.playing) {
          this.playing = false;
          this.stop();
        } else {
          this.playing = true;
          this.start();
        }
        this.updatePlayPauseUI();
      });

      if (this.autoplayEnabled) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => {
          if (this.playing) this.start();
        });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => {
          if (this.playing) this.start();
        });
      }

      this.updatePlayPauseUI();
      if (this.playing) this.start();
    }

    goTo(index) {
      if (index === this.index || !this.slides[index]) return;

      const current = this.slides[this.index];
      const next = this.slides[index];

      current.removeAttribute('data-state');
      current.setAttribute('inert', '');
      current.setAttribute('aria-hidden', 'true');

      next.setAttribute('data-state', 'active');
      next.removeAttribute('inert');
      next.removeAttribute('aria-hidden');

      this.dots[this.index]?.classList.remove('is-active');
      this.dots[this.index]?.setAttribute('aria-selected', 'false');
      this.dots[index]?.classList.add('is-active');
      this.dots[index]?.setAttribute('aria-selected', 'true');

      this.index = index;
    }

    next() {
      this.goTo((this.index + 1) % this.total);
    }

    start() {
      if (this.total <= 1) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    updatePlayPauseUI() {
      if (!this.playPauseButton) return;
      this.playPauseButton.setAttribute('aria-pressed', String(!this.playing));
      this.playPauseButton.classList.toggle('is-paused', !this.playing);
    }
  }

  if (!customElements.get('rehva-hero-stage')) {
    customElements.define('rehva-hero-stage', RehvaHeroStage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  class RehvaInstagramScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.button = this.closest('.rehva-instagram__inner')?.querySelector('[data-scroll-next]');

      if (!this.track) return;

      this.button?.addEventListener('click', () => {
        const tile = this.track.querySelector('.rehva-instagram__tile');
        const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
        const step = tile ? tile.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;

        this.track.scrollTo({
          left: atEnd ? 0 : this.track.scrollLeft + step,
          behavior: (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off')) ? 'auto' : 'smooth',
        });
      });

      this.updateArrow();
      this.track.addEventListener('scroll', () => this.updateArrow(), { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateArrow());
      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateArrow() {
      if (!this.button) return;
      this.button.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
    }
  }

  if (!customElements.get('rehva-instagram-scroller')) {
    customElements.define('rehva-instagram-scroller', RehvaInstagramScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-more-to-explore"] && !Shopify.designMode) return;
  try {
    
  class RehvaExploreCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      this.prevButton?.addEventListener('click', () => this.goPrev());
      this.nextButton?.addEventListener('click', () => this.goNext());
      this.track.addEventListener('scroll', () => this.updateNavState(), { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateNavState());
      this.resizeObserver.observe(this.track);

      this.updateNavState();
    }

    getStep() {
      const firstCard = this.track.children[0];
      if (!firstCard) return this.track.clientWidth;
      const trackStyle = getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0');
      return firstCard.getBoundingClientRect().width + gap;
    }

    goNext() {
      this.track.scrollBy({ left: this.getStep(), behavior: 'smooth' });
    }

    goPrev() {
      this.track.scrollBy({ left: -this.getStep(), behavior: 'smooth' });
    }

    updateNavState() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 4;
      this.classList.toggle('is-scrollable', scrollable);
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 4;
      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 4;
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  }

  if (!customElements.get('rehva-explore-carousel')) {
    customElements.define('rehva-explore-carousel', RehvaExploreCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-process-video"] && !Shopify.designMode) return;
  try {
    
  class RehvaProcessPlayer extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('[data-video]');
      this.toggle = this.querySelector('[data-mute-toggle]');

      if (!this.video) return;

      this.toggle?.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        this.toggle.setAttribute('aria-pressed', String(!this.video.muted));
      });

      this.reducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));

      if (this.reducedMotion) {
        this.video.pause();
        this.video.removeAttribute('autoplay');
        this.video.setAttribute('tabindex', '0');
        this.video.setAttribute('role', 'button');
        this.video.setAttribute('aria-label', this.dataset.playLabel || 'Play video');
        const playToggle = () => (this.video.paused ? this.video.play().catch(() => {}) : this.video.pause());
        this.video.addEventListener('click', playToggle);
      } else if (this.dataset.autoplay !== 'false' && 'IntersectionObserver' in window) {
        this.playObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            });
          },
          { threshold: 0.4 }
        );
        this.playObserver.observe(this.video);
      }
    }

    disconnectedCallback() {
      this.playObserver?.disconnect();
    }
  }

  if (!customElements.get('rehva-process-player')) {
    customElements.define('rehva-process-player', RehvaProcessPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-social-proof"] && !Shopify.designMode) return;
  try {
    
  class RehvaSocialProofCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.total = this.slides.length;
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => !slide.hasAttribute('hidden'))
      );
      this.track = this.querySelector('[data-slides]');
      this.animating = false;
      this.prefersReducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));

      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      this.prevButton?.addEventListener('click', () => {
        this.goTo(this.index - 1);
        this.#pauseAutoplay();
      });
      this.nextButton?.addEventListener('click', () => {
        this.goTo(this.index + 1);
        this.#pauseAutoplay();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index - 1);
          this.#pauseAutoplay();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + 1);
          this.#pauseAutoplay();
        }
      });

      this.#setupSwipe();
      this.#setupAutoplay();

      document.addEventListener('shopify:block:select', this.#handleBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.#handleBlockSelect);
      document.removeEventListener('visibilitychange', this.#handleVisibilityChange);
      window.clearTimeout(this.cleanupTimer);
      this.#stopAutoplay();
    }

    // `forward` decides slide direction: true reads as marquee-style
    // right-to-left travel (incoming enters from the right, outgoing exits
    // left) — the default compares the raw (pre-wrap) index so "next" and
    // autoplay always read forward while "previous" reverses it.
    goTo(index, forward = index > this.index) {
      if (this.total <= 1) return;

      const next = ((index % this.total) + this.total) % this.total;
      if (next === this.index) return;

      const current = this.slides[this.index];
      const upcoming = this.slides[next];
      this.index = next;

      if (!current || !upcoming) return;

      if (this.prefersReducedMotion || this.animating) {
        this.#swapInstant(current, upcoming);
        return;
      }

      this.#swapAnimated(current, upcoming, forward);
    }

    // Jumps without the slide transition — used only when the theme editor
    // selects a block directly, where an animated hand-off would be a
    // distracting mismatch with the merchant's click.
    #goToInstant(index) {
      if (this.total <= 1) return;

      const next = ((index % this.total) + this.total) % this.total;
      if (next === this.index) return;

      const current = this.slides[this.index];
      const upcoming = this.slides[next];
      this.index = next;

      if (current && upcoming) this.#swapInstant(current, upcoming);
    }

    #swapInstant(current, upcoming) {
      current.setAttribute('hidden', '');
      current.setAttribute('aria-hidden', 'true');
      upcoming.removeAttribute('hidden');
      upcoming.setAttribute('aria-hidden', 'false');
    }

    // Slides `current` out and `upcoming` in as a pair of overlapping,
    // absolutely-positioned layers so the transition can animate transform —
    // the resting state (a single slide in normal flow) is untouched, since
    // slides have very different heights and permanent absolute positioning
    // would either collapse the container or force a fixed min-height.
    #swapAnimated(current, upcoming, forward) {
      if (!this.track) {
        this.#swapInstant(current, upcoming);
        return;
      }

      this.animating = true;

      const enterFrom = forward ? '100%' : '-100%';
      const exitTo = forward ? '-100%' : '100%';
      const startHeight = current.getBoundingClientRect().height;

      this.track.style.height = `${startHeight}px`;

      current.classList.add('rehva-social-proof__slide--anim');
      upcoming.removeAttribute('hidden');
      upcoming.classList.add('rehva-social-proof__slide--anim');
      upcoming.style.transform = `translateX(${enterFrom})`;
      upcoming.style.opacity = '0';

      const endHeight = upcoming.getBoundingClientRect().height;

      // Force a style flush so the browser registers the starting position
      // above before the target styles below are applied — otherwise both
      // sets of styles land in the same frame and nothing animates.
      void upcoming.offsetWidth;

      const cleanup = () => {
        window.clearTimeout(this.cleanupTimer);
        current.setAttribute('hidden', '');
        current.setAttribute('aria-hidden', 'true');
        current.classList.remove('rehva-social-proof__slide--anim');
        current.style.transform = '';
        current.style.opacity = '';
        upcoming.classList.remove('rehva-social-proof__slide--anim');
        upcoming.style.transform = '';
        upcoming.style.opacity = '';
        upcoming.setAttribute('aria-hidden', 'false');
        this.track.style.height = '';
        this.animating = false;
        upcoming.removeEventListener('transitionend', cleanup);
      };

      upcoming.addEventListener('transitionend', cleanup);
      // Fallback in case a transitionend never fires (e.g. the element is
      // hidden by a tab switch mid-transition).
      this.cleanupTimer = window.setTimeout(cleanup, 650);

      requestAnimationFrame(() => {
        this.track.style.height = `${endHeight}px`;
        current.style.transform = `translateX(${exitTo})`;
        current.style.opacity = '0';
        upcoming.style.transform = 'translateX(0)';
        upcoming.style.opacity = '1';
      });
    }

    #handleBlockSelect = (event) => {
      if (!(event.target instanceof HTMLElement)) return;

      const slide = event.target.closest('[data-slide]');
      if (!slide || !this.contains(slide)) return;

      const index = this.slides.indexOf(slide);
      if (index > -1) this.#goToInstant(index);
    };

    #setupSwipe() {
      const track = this.querySelector('[data-slides]');
      if (!track) return;

      let startX = 0;
      let tracking = false;

      track.addEventListener('pointerdown', (event) => {
        tracking = true;
        startX = event.clientX;
      });

      track.addEventListener('pointerup', (event) => {
        if (!tracking) return;
        tracking = false;

        const delta = event.clientX - startX;
        if (Math.abs(delta) < 40) return;

        this.goTo(delta > 0 ? this.index - 1 : this.index + 1);
        this.#pauseAutoplay();
      });

      track.addEventListener('pointercancel', () => {
        tracking = false;
      });
    }

    #setupAutoplay() {
      if (!this.hasAttribute('data-autoplay') || this.total <= 1) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off')) return;

      const seconds = parseFloat(this.getAttribute('data-autoplay-interval')) || 5;
      this.autoplayDelay = Math.max(seconds, 2) * 1000;

      this.#startAutoplay();

      // Pause on hover/focus so a reading visitor isn't interrupted, resume on exit.
      this.addEventListener('mouseenter', this.#stopAutoplay);
      this.addEventListener('mouseleave', this.#startAutoplay);
      this.addEventListener('focusin', this.#stopAutoplay);
      this.addEventListener('focusout', this.#startAutoplay);

      document.addEventListener('visibilitychange', this.#handleVisibilityChange);
    }

    #startAutoplay = () => {
      if (!this.autoplayDelay || this.autoplayTimer || document.hidden) return;
      this.autoplayTimer = window.setInterval(() => {
        this.goTo(this.index + 1);
      }, this.autoplayDelay);
    };

    #stopAutoplay = () => {
      if (!this.autoplayTimer) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    };

    #handleVisibilityChange = () => {
      if (document.hidden) {
        this.#stopAutoplay();
      } else {
        this.#startAutoplay();
      }
    };

    // Manual interaction (arrows, keyboard, swipe) pauses autoplay for good —
    // resuming after a click reads as the carousel fighting the visitor.
    #pauseAutoplay() {
      this.autoplayDelay = null;
      this.#stopAutoplay();
    }
  }

  if (!customElements.get('rehva-social-proof-carousel')) {
    customElements.define('rehva-social-proof-carousel', RehvaSocialProofCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehva-ugc-video"] && !Shopify.designMode) return;
  try {
    
  class RehvaUgcScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.button = this.closest('.rehva-ugc__inner')?.querySelector('[data-scroll-next]');

      if (!this.track) return;

      this.button?.addEventListener('click', () => {
        const tile = this.track.querySelector('.rehva-ugc__tile');
        const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
        const step = tile ? tile.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;

        this.track.scrollTo({
          left: atEnd ? 0 : this.track.scrollLeft + step,
          behavior: (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off')) ? 'auto' : 'smooth',
        });
      });

      this.updateArrow();
      this.track.addEventListener('scroll', () => this.updateArrow(), { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateArrow());
      this.resizeObserver.observe(this.track);

      this.querySelectorAll('[data-mute-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const video = toggle.closest('.rehva-ugc__tile')?.querySelector('[data-video]');
          if (!video) return;
          video.muted = !video.muted;
          toggle.setAttribute('aria-pressed', String(!video.muted));
        });
      });

      this.videos = Array.from(this.querySelectorAll('[data-video]'));
      this.reducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));

      if (this.reducedMotion) {
        this.videos.forEach((video) => {
          video.setAttribute('tabindex', '0');
          video.setAttribute('role', 'button');
          video.setAttribute('aria-label', this.dataset.playLabel || 'Play video');
          const toggle = () => (video.paused ? video.play().catch(() => {}) : video.pause());
          video.addEventListener('click', toggle);
          video.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              toggle();
            }
          });
        });
      } else if (this.dataset.autoplay !== 'false' && this.videos.length && 'IntersectionObserver' in window) {
        this.playObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.videos.forEach((video) => this.playObserver.observe(video));
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.playObserver?.disconnect();
    }

    updateArrow() {
      if (!this.button) return;
      this.button.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
    }
  }

  if (!customElements.get('rehva-ugc-scroller')) {
    customElements.define('rehva-ugc-scroller', RehvaUgcScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-behind-the-print"] && !Shopify.designMode) return;
  try {
    
  class RehvaStoryPrint extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-reveal]'));
      const reducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.hasAttribute('data-rehva-motion-off'));

      if (!this.items.length) return;

      if (reducedMotion || !('IntersectionObserver' in window)) {
        this.items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
      );

      this.items.forEach((item) => observer.observe(item));
    }
  }

  if (!customElements.get('rehva-story-print')) {
    customElements.define('rehva-story-print', RehvaStoryPrint);
  }

  } catch(e) { console.error(e); }
})();
})();
